import { FaArrowDown, FaArrowUp } from 'react-icons/fa'

type SortDirection = 'asc' | 'desc'

type SortIndicatorProps<F extends string> = {
  field: F
  activeField: F
  direction: SortDirection
}

export function SortIndicator<F extends string>({ field, activeField, direction }: SortIndicatorProps<F>) {
  const isActive = activeField === field
  const Icon = direction === 'desc' ? FaArrowDown : FaArrowUp

  return (
    <span
      aria-hidden
      className={`inline-flex items-center justify-center overflow-hidden pointer-events-none transition-all duration-150 ${
        isActive ? 'ml-1 w-3 opacity-100' : 'ml-0 w-0 opacity-0'
      } md:ml-1 md:w-3 ${isActive ? 'md:opacity-100' : 'md:opacity-0'}`}
    >
      <Icon className="h-3 w-3 shrink-0" />
    </span>
  )
}
